import { StringParam, NumberParam, DecodedValueMap, SetQuery } from 'use-query-params'

export const feedbackParams = {
  marketplace: StringParam,
  score: NumberParam,
  page: NumberParam,
}

export type TFeedbackParams = DecodedValueMap<typeof feedbackParams>
export type TFeedbackSetParams = SetQuery<typeof feedbackParams>
